import { useEffect } from 'react';
const PIXEL_ID = '1760016611876780';
declare global {
  interface Window {
    fbq?: ((...args: unknown[]) => void) & {
      callMethod?: (...args: unknown[]) => void;
      queue?: unknown[];
      push?: unknown;
      loaded?: boolean;
      version?: string;
    };
    _fbq?: unknown;
  }
}

/**
 * Meta Pixel loader. The script tag is injected after mount (and after the
 * first paint) so it never blocks the initial render of the page.
 */
export function MetaPixel() {
  useEffect(() => {
    if (window.fbq) return;
    const fbq: any = function (...args: unknown[]) {
      fbq.callMethod ? fbq.callMethod.apply(fbq, args) : fbq.queue.push(args);
    };
    fbq.queue = [];
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = '2.0';
    window.fbq = fbq;
    window._fbq = fbq;
    const load = () => {
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
      window.fbq?.('init', PIXEL_ID);
      window.fbq?.('track', 'PageView');
    };
    const idle = (window as any).requestIdleCallback as undefined | ((cb: () => void, opts?: {
      timeout: number;
    }) => number);
    if (idle) {
      const handle = idle(load, {
        timeout: 2500
      });
      return () => (window as any).cancelIdleCallback?.(handle);
    }
    const timer = window.setTimeout(load, 1200);
    return () => window.clearTimeout(timer);
  }, []);
  return null;
}